import React, { Component } from "react";
import Cell from "./Cell";

export default class Row extends Component {
  render() {
    let row = this.props.row;

    return (
      <div className="row justify-content-center flex-grow-1">
        {row.map((cell, index) => (
          <Cell
            onCellClick={() => {
              this.props.onCellClick(this.props.rowIndex, index, cell.special)
            }}
            key={"cell" + index}
            cell={cell}
          />
        ))}
      </div>
    );
  }
}
